import type {ValueProvider} from '../util/ValueProvider';

import {RefreshTriggerBase} from './RefreshTriggerBase';

export class NavigationTrigger extends RefreshTriggerBase {
    enabledProvider: ValueProvider<boolean>;

    constructor(enabledProvider: ValueProvider<boolean>) {
        super();
        this.enabledProvider = enabledProvider;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    init(visible: boolean) {

    }

    show() {

    }

    hide() {

    }

    onUpdate() {
        if (this.enabledProvider.getValue()) {
            this.refresh();
        }
    }

    destroy() {

    }
}
